import * as React from 'react';

import {SpinnerReact} from 'common/components/spinner';
import {PROPERTY_BREAKDOWN_MAP} from 'common/onboarding/immersive-onboarding/constants';

import {BarPreview} from './charts/bar';
import {ChartPreviewCarousel} from './chart-preview-carousel';
import {FunnelPreview} from './charts/funnel';
import {LinePreview} from './charts/line';
import {BarBreakdownPreview} from './charts/bar-breakdown';
import {StackedBarBreakdownPreview} from './charts/stacked-bar-breakdown';
import {FunnelBreakdownPreview} from './charts/funnel-breakdown';

const CHART_PREVIEW_MAX = 4;

export const EventChartPreviewCarousel = ({events}) => {
  if (!events || events.length === 0) {
    return <SpinnerReact />;
  }

  const eventsToShow = events.slice(0, CHART_PREVIEW_MAX);

  return (
    <ChartPreviewCarousel>
      <FunnelPreview events={eventsToShow} />
      <LinePreview events={eventsToShow} cardTitle='What is the trend over the last month?' />
      <BarPreview events={eventsToShow} cardTitle='How many users did these actions this year?' />
    </ChartPreviewCarousel>
  );
};

export const PropertyBreakdownPreviewCarousel = ({events, property}) => {
  if (!events || events.length === 0) {
    return <SpinnerReact />;
  }

  const eventsToShow = events.slice(0, CHART_PREVIEW_MAX);

  return (
    <ChartPreviewCarousel>
      <FunnelBreakdownPreview events={eventsToShow} properties={PROPERTY_BREAKDOWN_MAP[property]} property={property} />
      <StackedBarBreakdownPreview events={eventsToShow} property={property} />
      <BarBreakdownPreview events={eventsToShow} property={property} />
    </ChartPreviewCarousel>
  );
};

export const PropertyBreakdownPreviewCarouselV2 = ({events, property, breakdown, pauseRotation, selectedEvent}) => {
  let toShow = [];
  if (!breakdown?.length) {
    toShow = [`Property A`, `Property B`, `Property C`];
  } else {
    toShow = breakdown.slice(0, CHART_PREVIEW_MAX);
  }
  const lineCardDefaultTitle = `What is the trend over the last month?`;
  const FunnelCardDefaultTitle = `Where do mobile vs desktop users drop off?`;
  const BarCardDefaultTitle = `How many users did these actions this year?`;

  const cardTitle = `${selectedEvent} by ${property}`;

  const missingTitleInfo = !selectedEvent || !property;

  return (
    <ChartPreviewCarousel pauseRotation={pauseRotation}>
      <LinePreview events={toShow} cardTitle={missingTitleInfo ? lineCardDefaultTitle : cardTitle} />
      <FunnelBreakdownPreview
        events={events.slice(0, CHART_PREVIEW_MAX)}
        property={property}
        properties={toShow}
        cardTitle={missingTitleInfo ? FunnelCardDefaultTitle : cardTitle}
      />
      <BarPreview events={toShow} cardTitle={missingTitleInfo ? BarCardDefaultTitle : cardTitle} />
    </ChartPreviewCarousel>
  );
};
